import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  constructor(private cookieService: CookieService) {}

  get SiteIsDark(): boolean {
    return this.cookieService.get('SiteIsDark') == 'true';
  }
  set SiteIsDark(siteIsDark: boolean) {
    this.cookieService.set('SiteIsDark', siteIsDark.toString(), 365);
  }
  get SiteIsLigth(): boolean {
    return !this.SiteIsDark;
  }

  get NavigationIsHorizontal(): boolean {
    return this.cookieService.get('NavigationIsHorizontal') == 'true';
  }
  set NavigationIsHorizontal(navigationIsHorizontal: boolean) {
    this.cookieService.set('NavigationIsHorizontal', navigationIsHorizontal.toString(), 365);
  }
  get NavigationIsVertical(): boolean {
    return !this.NavigationIsHorizontal;
  }

  get MenuIsStatic(): boolean {
    return this.cookieService.get('MenuIsStatic') == 'true';
  }
  set MenuIsStatic(menuIsStatic: boolean) {
    this.cookieService.set('MenuIsStatic', menuIsStatic.toString(), 365);
  }
}
